module.exports = __webpack_public_path__ + "static/logo_ysy_cloud_nb-84b5711608ca2fe23411fcb07f4bb48b.svg";